import { colorToCss } from "../../color/color"
import { defineDirective } from "../../utils/angular"
import { ColorPickerOptions } from "./cp"

/** @internal */
export class ColorPickerButton {

    static create() {
        return defineDirective(ColorPickerButton, "shared/components/color-picker/cp-button.html", {
            color: "=?",
            options: "=",
            disabled: "=",
        })
    }


    public color: number[]

    public options: ColorPickerOptions & {
        closeWhenSelected?: boolean
    }

    public isOpen: boolean

    static $inject = ["$scope"]

    constructor(private $scope: ng.IScope) {
        this.$scope.$watch("vm.color", () => {
            if (this.isOpen && this.options && this.options.closeWhenSelected) {
                this.isOpen = false
            }
        })
    }

    getCurrentCssColor(): string {
        if (this.color) {
            return colorToCss(this.color)
        }
    }

}
